import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#CE3030',
    },
    secondary: {
      main: '#F09C20',
    },
    whiteText: {
      main: '#F0E5D5',
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#F0E5D5',
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        root: {
          color: '#F0E5D5',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#F0E5D5',
        },
      },
    },
  },
});
